import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ASYNC_USER_LOGIN } from 'store';
import { Link, Redirect } from 'react-router-dom';
import { Form, Button, Alert, Row, Col, Container, InputGroup, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import LoginService from '../../services/login';
import * as logo from "../../images/logo-dark.png";
import * as logoWhite from "../../images/logo-branco-scan.png";
import { CompanyType } from '../../helpers/Enum/index';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Params from '../../helpers/Params';
import { SubmitButton } from 'react-dropzone-uploader';
import './style.scss';

const RegisterPassword = () => {
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');

  const [isNotAuthorized, setNotAuthorized] = useState(false);
  const [isChecking, setChecking] = useState(true);
  const [isLoad, setLoad] = useState(false);
  const [isSavedPassword, setSavedPassword] = useState(false);


  var hidden = true;

  const { t } = useTranslation();

  useEffect(() => {
    let id = Params.get('id');
    let token = Params.get('token');
    let response = LoginService.register_password_verify_token(id, token);
    response.then((data) => {
      setChecking(false);
    }).catch((error) => {
      if(error.response.status === 404){
        //setMessage({...{show:true, error:true}});
        setNotAuthorized(true);
      }else{
        console.erro(error.response);
      }
      //setLoad(false);
    });
  }, [])

  const submit = (password1,password2) => {
    let id = Params.get('id');
    let token = Params.get('token');
    setLoad(true);
    let response = LoginService.register_password(id, token, password1);
    response.then((data) => {
      setLoad(false);
      setSavedPassword(true);
    }).catch((error) => {
      if(error.response.status === 404){
        //setMessage({...{show:true, error:true}});
        setNotAuthorized(true);
      }else{
        console.erro(error.response);
      }
      setLoad(false);
    });
  }
  if(isNotAuthorized)
  return <Redirect to='/login' />;

  const minWidth = 940;
  const isMobile = window.innerWidth <= minWidth;

  if(!isChecking)
  return (
    <>
      <div className={isMobile?"bg-scansource pl-3":''} style={{height:'100vh'}}>
      <Row className={isMobile?"bg-scansource p-3":''} style={{height:'100vh'}}>
        <Col md="5" className={(isMobile?'':'p-5')+" col-login"} style={{background:'white'}}>
          <div className="scan-logo">
            <span>
              <img src={logo} alt="ScanSource" width={!isMobile?"250":'200'}  />
            </span>
          </div>
          <div className="login-text">
            <h5 className="login-h5">Registrar uma senha.</h5>
            <span className="login-span">Insira uma senha</span>
          </div>
          {!isSavedPassword?(
            <Form className="login-form"
              onSubmit={e => {
                e.preventDefault();
                submit(password1,password2);
              }}
            >
              <Form.Group>
                <Form.Label className="form-label">{t('label:password')}</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>
                      <LockOutlinedIcon className="icon-input" />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="password"
                    onChange={e => setPassword1(e.target.value)}
                    className="input-size"
                    required
                  />
                </InputGroup>
              </Form.Group>
  
              <Form.Group>
                <Form.Label className="form-label">Confirmar senha:</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>
                      <LockOutlinedIcon className="icon-input" />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="password"
                    onChange={e => setPassword2(e.target.value)}
                    className="input-size"
                    required
                  />
                </InputGroup>
              </Form.Group>
              {isLoad?(
                <p className="text-center mt-2">
                <Spinner animation="border" style={{color:'#e05c17'}}/>
                </p>
              ):(
              <Button block type="submit" className="login-btn">
              Salvar senha
              </Button>
              )}
            </Form>
          ):(<>
            <Container className="pl-5 pr-5">
              <Alert variant="success">
                Senha Salva
              </Alert>
            </Container>
            <p className="text-center mt-2">
              
              <Link to="/login" className="forgot-password">
                Fazer login
              </Link>
            </p>
          </>)}
        </Col>
        {!isMobile?(
          <Col md="7" className="bg-scansource">
            {/* <div className="scan-logo-white">
              <span>
                <img src={logoWhite} alt="ScanSource" width="250" />
              </span>
            </div>
            <div className="scan-site mt-3">
              <span>
                www.scansource.com.br
              </span>
            </div> */}
          </Col>
        ):''}
        </Row>
      </div>
    </>
  );
  
  return (<>Verificando</>);
};

export default RegisterPassword;